function DislikeIcon({ className }) {
  return (
    <div className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M14.6246 1.6875H6.07151C4.19951 1.6875 3.74128 2.59727 3.40303 3.61052L1.90376 8.11052C1.55276 9.16352 1.62928 10.1168 2.11753 10.794C2.45203 11.259 3.15026 11.8125 4.57151 11.8125H6.93852V13.6777C6.93852 14.6198 7.40657 15.4943 8.19032 16.0178C8.48282 16.2128 8.81954 16.3132 9.16004 16.3132C9.34079 16.3132 9.52227 16.2847 9.70002 16.2277C10.213 16.0627 10.6151 15.6795 10.8108 15.1537L12.4068 10.3125H14.6238C15.5538 10.3125 16.3113 9.55575 16.3113 8.625V3.375C16.3121 2.44425 15.5546 1.6875 14.6246 1.6875ZM11.4663 9.57376L9.75102 14.7795C9.68277 14.9602 9.53953 15.0975 9.35578 15.1567C9.17128 15.216 8.97482 15.1883 8.81507 15.0818C8.34482 14.7683 8.06434 14.2432 8.06434 13.6777V11.25C8.06434 10.9395 7.81234 10.6875 7.50184 10.6875H4.57234C4.05034 10.6875 3.35881 10.5923 3.03031 10.1363C2.76331 9.76501 2.74081 9.15677 2.97181 8.46602L4.47108 3.96602C4.73733 3.16577 4.90451 2.81177 6.07151 2.81177H11.9996V9.18677C11.7566 9.18827 11.542 9.34351 11.4663 9.57376ZM15.1871 8.625C15.1871 8.9355 14.9343 9.1875 14.6246 9.1875H13.1246V2.8125H14.6246C14.9343 2.8125 15.1871 3.0645 15.1871 3.375V8.625Z'
          fill='#DC3545'
        />
      </svg>
    </div>
  );
}

export default DislikeIcon;
